<ng-container *ngIf="remoteConfigStore.remoteConfig$ | async as remoteConfig">
  <ng-container *ngrxLet="authStore.isCommercialUser$ as isCommercialUser">
    <vi-page [sidenavs]="true" [footer]="true" *ngIf="invitationsStore.state$ | async as state">
      <app-commercial-toolbar *appForCommercialUser="true" head></app-commercial-toolbar>
      <app-downtime-notification head></app-downtime-notification>
      <app-callback-notification head></app-callback-notification>
      <vi-toolbar *ngIf="!isCommercialUser" head color="white">
        <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="invitations"></vi-back-button>
        <vi-breadcrumbs
          left
          gtm="onBreadcrumb"
          gtmCategory="invitations"
          formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
          currentPage="{{ 'GENERAL.PATH.INVITATIONS' | translate }}"
          [navigateTo]="'/installations'"
        ></vi-breadcrumbs>
      </vi-toolbar>

      <!-- Desktop header -->
      <vi-header
        *ngIf="!isCommercialUser"
        class="lt-lg:!hidden"
        head
        data-at-header
        color="white"
        direction="row"
        layoutAlign="justify-between items-start"
      >
        <div class="invitation-message flex flex-col gap-[12px] flex-[100%] max-w-[100%]">
          <h1 class="flex-auto" data-at-invitations-title>
            {{ '+INVITATIONS.INVITATIONS.TITLE' | translate }}
          </h1>
          <vi-text class="flex-auto">
            <div data-at-invitations-description content>
              {{ '+INVITATIONS.INVITATIONS.DISCRIPTION' | translate }}
            </div>
          </vi-text>
        </div>
        <div
          *ngIf="remoteConfig?.createNewInvitationAvailable"
          class="flex flex-row justify-end items-center flex-[280px] max-w-[280px]"
        >
          <button
            data-at-new-invitation
            class="new-invitation-btn"
            mat-stroked-button
            gtm="onOpen"
            gtmAction="New invitation dialog"
            gtmCategory="invitations"
            (click)="onNewInvitation()"
          >
            <mat-icon>person_add</mat-icon>
            <span>{{ '+INVITATIONS.INVITATIONS.NEW_INVITATION_BUTTON' | translate }}</span>
          </button>
        </div>
      </vi-header>

      <!-- Mobile header -->
      <vi-header
        *ngIf="!isCommercialUser"
        class="gt-md:!hidden"
        head
        data-at-header
        color="white"
        direction="col"
        layoutAlign="justify-start items-start"
      >
        <div
          class="invitation-message flex flex-row flex-wrap gap-[12px] justify-between items-center"
        >
          <h1 data-at-invitations-title-sm>
            {{ '+INVITATIONS.INVITATIONS.TITLE' | translate }}
          </h1>
          <button
            data-at-new-invitation
            *ngIf="remoteConfig?.createNewInvitationAvailable"
            class="new-invitation-btn"
            mat-stroked-button
            gtm="onOpen"
            gtmAction="New invitation dialog"
            gtmCategory="invitations"
            (click)="onNewInvitation()"
          >
            <mat-icon>person_add</mat-icon>
            <span>{{ '+INVITATIONS.INVITATIONS.NEW_INVITATION_BUTTON' | translate }}</span>
          </button>
        </div>
        <vi-text>
          <div data-at-invitations-description-sm content>
            {{ '+INVITATIONS.INVITATIONS.DISCRIPTION' | translate }}
          </div>
        </vi-text>
      </vi-header>

      <vi-progress-bar head [isLoading]="state.loaded && state.loading"></vi-progress-bar>

      <vi-content body *ngIf="!state.loaded && state.loading">
        <vi-loader
          main
          data-at-loader
          asCard="true"
          [isLoading]="true"
          [message]="'+USER_REGISTRATION.USER_REGISTRATION.LOADING_MESSAGES.DATA' | translate"
        >
        </vi-loader>
      </vi-content>

      <vi-content body class="filter-content">
        <app-chip-filters main *ngIf="state.isData && !isCommercialUser">
          <app-chip-filter
            data-at-filter-all
            [active]="state.activeFilter === ActiveInvitationsFilterType.All"
            [count]="state.invitationsIds.all.length"
            gtm="onSetFilter"
            gtmAction="All invitations"
            gtmCategory="invitations"
            (click)="filterInvitations(ActiveInvitationsFilterType.All)"
          >
            {{ '+INVITATIONS.INVITATIONS.ALL' | translate }}
          </app-chip-filter>
          <app-chip-filter
            data-at-filter-incoming
            icon="inbox"
            [active]="state.activeFilter === ActiveInvitationsFilterType.Incoming"
            [count]="state.invitationsIds.incoming.length"
            gtm="onSetFilter"
            gtmAction="Incoming invitations"
            gtmCategory="invitations"
            (click)="filterInvitations(ActiveInvitationsFilterType.Incoming)"
          >
            {{ '+INVITATIONS.INVITATIONS.INCOMING' | translate }}
          </app-chip-filter>
          <app-chip-filter
            data-at-filter-pending
            *ngIf="remoteConfig?.createNewInvitationAvailable"
            icon="schedule"
            [active]="state.activeFilter === ActiveInvitationsFilterType.Pending"
            [count]="state.invitationsIds.pending.length"
            gtm="onSetFilter"
            gtmAction="Pending invitations"
            gtmCategory="invitations"
            (click)="filterInvitations(ActiveInvitationsFilterType.Pending)"
          >
            {{ '+INVITATIONS.INVITATIONS.PENDING' | translate }}
          </app-chip-filter>

          <!-- Do not display DECLINED and EXPIRED invitations for now -->
          <!-- <app-chip-filter
            icon="highlight_off"
            [active]="state.activeFilter === 'declined'"
            [count]="state.invitationsIds.declined.length"
            gtm="onSetFilter"
            gtmAction="Declined invitations"
            gtmCategory="invitations"
            (click)="filterInvitations(ActiveInvitationsFilterType.Declined)"
          >
            {{ '+INVITATIONS.INVITATIONS.DECLINED' | translate }}
          </app-chip-filter>
          <app-chip-filter
            icon="error_outline"
            [active]="state.activeFilter === 'expired'"
            [count]="state.invitationsIds.expired.length"
            gtm="onSetFilter"
            gtmAction="Expired invitations"
            gtmCategory="invitations"
            (click)="filterInvitations(ActiveInvitationsFilterType.Expired)"
          >
            {{ '+INVITATIONS.INVITATIONS.EXPIRED' | translate }}
          </app-chip-filter> -->
        </app-chip-filters>
      </vi-content>

      <ng-container body *ngIf="isCommercialUser; else maintainerInvitations">
        <div
          body
          *ngIf="state.loaded && state.isData"
          data-at-invitations
          class="customer-invitations"
        >
          <app-commercial-invitation
            main
            data-at-inv
            *ngFor="let token of state.invitationsIds[state.activeFilter]"
            class="flex-[400px] max-w-[400px] lt-md:flex-[100%] lt-md:max-w-[100%]"
            [owner]="state.commercialInvitations[token]"
            [invitation]="state.invitations[token]"
          ></app-commercial-invitation>
        </div>
      </ng-container>

      <ng-template #maintainerInvitations>
        <vi-content
          body
          *ngIf="state.loaded && state.isData"
          data-at-invitations
          direction="row"
          [wrap]="true"
          layoutAlign="justify-between items-start"
          gap="0px"
        >
          <app-invitation
            main
            data-at-inv
            *ngFor="let token of state.invitationsIds[state.activeFilter]"
            class="flex-[496px] max-w-[496px] lt-md:flex-[100%] lt-md:max-w-[100%]"
            [demo]="authStore.isDemo$ | async"
            [invitation]="state.invitations[token]"
            [owner]="state.ownerDetails[token]"
            [installation]="state.installationDetails[token]"
            [companyId]="authStore.getCompanyId() | async"
            (accept)="onAccept($event)"
            (reject)="onReject($event)"
            (cancel)="onCancel($event)"
          ></app-invitation>
        </vi-content>
      </ng-template>

      <vi-content body [centered]="true" *ngIf="state.loaded && !state.isData">
        <vi-empty
          main
          header="{{ '+INVITATIONS.NO_INVITATIONS_HEADER' | translate }}"
          content="{{ '+INVITATIONS.NO_INVITATIONS_CONTENT' | translate }}"
          redirectBtn="{{ '+INVITATIONS.NO_INVITATIONS_BTN' | translate }}"
          redirectLink="/installations"
          imgSrc="/assets/img/no-invitations@2x.png"
          gtm="onGoToPage"
          gtmAction="Installations"
          gtmCategory="invitations"
        >
        </vi-empty>
      </vi-content>

      <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
      <app-sidenav left-sidenav></app-sidenav>
    </vi-page>
  </ng-container>
</ng-container>
